/** 5 minutes */
export const DEFAULT_STORAGE_DURATION = 300
